import React, { useEffect, useState } from 'react';
import { Table, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import EditItemModal from '../components/EditItemModal';
import Loading from '../components/Loading';
import { deleteExtraPayment } from '../services/RequestsPendingToPayService';
import { getItemsByRequestId, deleteItem } from '../services/Services';

const getUserId = () => localStorage.getItem('userId') ?? 0;

const RequestItemsTable = ({ id, reload, onDeleteSuccess, handleEditExtraPayment }) => {
    const userId = parseInt(getUserId());
    const [data, setData] = useState({ regularItems: [], formattedExtraPayments: [] });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [itemId, setItemId] = useState(0);
    const [showEditItemModal, setShowEditItemModal] = useState(false);

    const fetchData = () => {
        if (!id || parseInt(id) === 0) {
            setData({ regularItems: [], formattedExtraPayments: [] });
            setLoading(false);
            setError(null);
            return;
        }

        setLoading(true);
        setError(null);
        getItemsByRequestId(id)
            .then(list => setData(list))
            .catch(error => setError(error))
            .finally(() => setLoading(false));
    };

    const handleEditItem = (id) => {
        setItemId(id);
        setShowEditItemModal(true);
    };

    const handleDeleteExtraPayment = (id) => {
        deleteExtraPayment(id, userId).then(result => {
            if (result) {
                toast.success('Registro eliminado correctamente');
                fetchData();
                if (onDeleteSuccess) {
                    onDeleteSuccess();
                }
            } else {
                toast.error('Lo sentimos, algo salió mal.');
            }
        });
    };

    const handleDelete = (itemId) => {
        deleteItem(itemId)
            .then(result => {
                if (result.result) {
                    toast.success('Registro eliminado correctamente');
                    fetchData();
                    if (onDeleteSuccess) {
                        onDeleteSuccess();
                    }
                } else {
                    toast.error('Lo sentimos, algo salió mal.');
                }
            })
            .catch((error) => {
                console.error('Error deleting item:', error);
                toast.error('Lo sentimos, algo salió mal.');
            });
    };

    const splitReason = (reason) => {
        const raw = (reason ?? '').trim();
        if (!raw) return { concept: '', subconcept: '', detail: '' };
        const parts = raw.split('/').map(p => p.trim()).filter(Boolean);
        return { concept: parts[0] ?? '', subconcept: parts[1] ?? '', detail: parts.slice(2).join(' / ') ?? '' };
    };

    useEffect(() => {
        // si aún no hay requestId, no hay nada que cargar
        if (!id || parseInt(id) === 0) {
            setData({ regularItems: [], formattedExtraPayments: [] });
            setLoading(false);
            setError(null);
            return;
        }

        fetchData();
    }, [id, reload]);

    if (loading) return <Loading />;
    if (error) return <div>Error: {error.message}</div>;

    return (
        <div>
            <Table className='mt-3' striped bordered responsive>
                <thead>
                    <tr>
                        <th className='text-center'></th>
                        <th className='text-center'></th>
                        <th className='text-center'>Concepto</th>
                        <th className='text-center'>Subconcepto</th>
                        <th className='text-center'>Detalle</th>
                        <th className='text-center'>Horas</th>
                        <th className='text-center'>Fecha</th>
                        <th className='text-center'>Trabajo desde casa</th>
                        <th className='text-center'>A pagar</th>
                    </tr>
                </thead>
                <tbody>
                    {data.regularItems.map((item, index) => {
                        const rr = splitReason(item.reason);
                        const parts = (item.reason ?? '').split('/').map(p => p.trim()).filter(Boolean);
                        const hasSubconcept = parts.length >= 3;

                        // Concepto
                        const concept = parts[0] ?? '-';

                        // Subconcepto
                        const subconcept = hasSubconcept ? (parts[1] ?? 'N/A') : 'N/A';

                        // Detalle
                        const detail = hasSubconcept
                            ? (parts.slice(2).join(' / ') || '-')
                            : (parts[1] || '-');

                        return (
                            <tr key={index}>
                                <td className='text-center'>
                                    <Button onClick={() => handleDelete(item.id)} type="button" variant='danger'>Eliminar</Button>
                                </td>
                                <td className='text-center'>
                                    <Button onClick={() => handleEditItem(item.id)} variant='warning'>Editar</Button>
                                </td>
                                <td className='text-center'>{concept}</td>
                                <td className='text-center'>{subconcept}</td>
                                <td className='text-center'>{detail}</td>
                                <td className='text-center'>{item.hours}</td>
                                <td className='text-center'>{item.formattedDate}</td>
                                <td className='text-center'>{item.itsWorkFromHome ? "Si" : "No"}</td>
                                <td className='text-center'>No disponible</td>
                            </tr>
                        );
                    })}
                    {data.formattedExtraPayments.map((item, index) => (
                        <tr key={index}>
                            <td className='text-center'>
                                <Button onClick={() => handleDeleteExtraPayment(item.id)} type="button" variant='danger'>Eliminar</Button>
                            </td>
                            <td className='text-center'>
                                <Button onClick={() => handleEditExtraPayment(item.id)} variant='warning'>Editar</Button>
                            </td>

                            {/* Concepto / Subconcepto / Detalle */}
                            <td className='text-center'>N/A</td>
                            <td className='text-center'>N/A</td>
                            <td className='text-center'>{item.reason}</td>

                            {/* Horas / Fecha / WFH / A pagar */}
                            <td className='text-center'>N/A</td>
                            <td className='text-center'>{item.formattedDate}</td>
                            <td className='text-center'>N/A</td>
                            <td className='text-center'>$ {item.pay}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <EditItemModal
                show={showEditItemModal}
                handleClose={() => { setShowEditItemModal(false); setItemId(0); fetchData(); }}
                itemId={itemId}
            />
        </div>
    );
};

export default RequestItemsTable;